import { ActionButton } from './ActionButton';
import { titleOf } from './outstanding';
import type { OutstandingItem } from './outstanding.schema';
import { primaryActionOf, secondaryActionsOf, type OutstandingAction } from './rowActions';
import { RowActionsMenu } from './RowActionsMenu';

interface ItemActionBarProps {
  item: OutstandingItem;
  onSelect: (item: OutstandingItem, action: OutstandingAction) => void;
  /** Lets the primary action span the card on a phone, where a small button
   *  floating in a wide row is both hard to hit and hard to find. The overflow
   *  trigger stays on the same line beside it — stacking it put a lone icon on
   *  a row of its own. From `sm` up the pair sits right, where a card's actions
   *  belong. */
  fullWidth?: boolean;
}

/**
 * The Pay / Sign / overflow controls for one outstanding document.
 *
 * Extracted so the dashboard row, the Changes tab and the Annual Reviews tab
 * all render the same controls from the same conditions. The legacy portal
 * re-implemented these guards on each screen, which is how the Changes tab
 * ended up offering "Sign" on documents the director had already signed.
 */
export const ItemActionBar = ({ item, onSelect, fullWidth = false }: ItemActionBarProps) => {
  const primary = primaryActionOf(item);
  const secondary = secondaryActionsOf(item);

  if (primary === undefined && secondary.length === 0) return null;

  return (
    <div
      className={
        fullWidth ? 'flex items-center gap-2 sm:justify-end' : 'flex items-center gap-1'
      }
    >
      {primary !== undefined && (
        <ActionButton
          action={primary}
          fullWidth={fullWidth}
          onSelect={(action) => {
            onSelect(item, action);
          }}
        />
      )}
      <RowActionsMenu
        actions={secondary}
        itemLabel={`${titleOf(item)}, ${item.asicCompanyName}`}
        onSelect={(action) => {
          onSelect(item, action);
        }}
      />
    </div>
  );
};
